import { IEdition } from 'src/interfaces/Edition';

export const hasEditionAccountingData = (edition: IEdition): boolean =>
  edition.checkinsByPrice != null &&
  Object.keys(edition.checkinsByPrice).length > 0 &&
  edition.totalPrice != null;

export const getEditionsWithAccountingData = (editions: IEdition[]): IEdition[] =>
  editions.filter(hasEditionAccountingData);

export const buildRevenueChartData = (
  editions: IEdition[],
): { labels: string[]; values: number[]; editionIds: string[] } => {
  const withData = getEditionsWithAccountingData(editions).sort((a, b) => a.year - b.year);

  return {
    labels: withData.map(e => String(e.year)),
    values: withData.map(e => e.totalPrice as number),
    editionIds: withData.map(e => e.id),
  };
};

export const resolveDefaultAccountingEditionId = (
  editions: IEdition[],
  activeEditionId?: string,
): string | null => {
  if (editions.length === 0) {
    return null;
  }

  if (activeEditionId) {
    const active = editions.find(e => e.id === activeEditionId);
    if (active && hasEditionAccountingData(active)) {
      return activeEditionId;
    }
  }

  const withData = getEditionsWithAccountingData(editions);
  if (withData.length > 0) {
    return withData.reduce((latest, e) => (e.year > latest.year ? e : latest)).id;
  }

  return editions[0]?.id ?? null;
};
